export enum EnumGeometryTypes {
    Polygon = 1,
    Buffer = 2,
    Zone = 3
}